
import axios from 'axios';
import { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import { BASE_URL, Image_URL } from '../../App';
import '../../styles/profilecourses.css'
import ScrollTopButton from '../ScrollTop';
import SidebarProfile from '../SidebarProfile';

function Profilecourses () {

      const [cards , setCards] = useState([]);
      const [isLoading, setIsLoading] = useState(true);

    
    useEffect(() => {
      
        window.scrollTo(0, 0);
 
              const token = localStorage.getItem('token');
              const config = {
                headers: {
                  'Content-Type': 'application/json',
                  "ngrok-skip-browser-warning": "any",
                  'Authorization': `Bearer ${token}`,
                }
              };       
              axios.get(`${BASE_URL}/api/my-weeks` , config)
                .then(response => {
                  // console.log(response.data.data);
                  setCards(response.data.data);
                  setIsLoading(false)
                })
                .catch(error => {
                  // console.error(error);
                  setIsLoading(false)
                });
            }, [])

            function formatDate(dateString) {
              try {
                const date = new Date(dateString);
                const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC', numberingSystem: 'arab'};
                const formatter = new Intl.DateTimeFormat('ar-EG', options);
                const formattedDate = formatter.format(date);
                return formattedDate;
              } catch (e) {
                // console.error('Error formatting date', e);
                return '';
              }
            }

            
            if (isLoading) {
              return <div className="main-loading">
                <div className="loading-course"> 
              <h2>  .... جاري تحميل كورساتك</h2>
              </div>; 
              </div>
            }

            

    return (
        <>
             <div className="profile-course">
             <div className="profile-ground">
                                <img src="/images/bg.3b55416e926d51a05f75.png" alt=""/>
                        </div>
            <Container>
                <Row>
                    <Col lg={12}>
                     
                        <div className="profile-user pt-5">
                        <div className="title-profile mt-5 mb-5">
                  <button class="button-prof" role="button"> كورساتك </button>
                       </div>                           
                     <Container>
                                <Row >
                                    <Col lg={9} className="">
                                    {
                                      cards.length > 0
                                      ?
                                      <div className="main-info ">
                                      <Container>
                                          <Row className="" >
                        {
                          cards.map((props) => {
                            return(
                            
                           <Col lg={6} md={12} key={props.id}  className="mb-5"> 
            <div className="main">
                        <div className="card shadow2">
                      <div className="images">
                      <img src={`${Image_URL}/storage/${props.img}`} alt=""/>

                      {/* <img src="/images/Logo.jpeg" alt=""/> */}
                      </div>
                      <div className="details mt-4">
                      <h2>{props.name}</h2>
                      <div className="line"></div>
                      <p>{props.description}</p>
                      </div>
                      <div className="price-date">

                     
                                
                            <div className="subed">
                                    أنت مشترك في هذا الكورس
                                                     !
                              </div>

            <div className="dates d-flex ms-2">
                <span className="date d-flex">
                {formatDate(props.created_at)}
                  <img src="/images/email.png" alt=""/>
                  </span>
                <span className="date d-flex mt-1">
                 {formatDate(props.updated_at)}
                  <img src="/images/add-friend.png" alt=""/>
                  </span>
              </div>     
                   <div className="btns">
          <div></div>
            <Link to={`/contentcourse/${props.id}`}  className="buy">الدخول للكورس </Link>
          </div>      
               </div>
                      
        </div>
            </div>
          </Col>
                              
                            )
                          })
                        }
                                          </Row>
                                      </Container>
                                </div>
                                :
                                    <div className="no-courses" style={{background:"#fff"}}>
                    
                            <h2> !لا تتوفر كورسات حتي الأن </h2>
                        </div>
                                    }
                                    </Col>
                                
                                    <Col lg={3}>
                                      <SidebarProfile />
                                    </Col>
                                </Row>
                                </Container>
                            </div>
                        
                    
                    </Col>
                </Row>

            </Container>
        </div>
        < ScrollTopButton />

        </>
    )
}

export default Profilecourses;